import React from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';
import FormItem from './FormItem';
import NotEditableItem from './NotEditableItem';

const { MonthPicker } = DatePicker;

export default function FormDatePicker({ editable, name, value, error, onChange, layout, label, required, picker = '', ...props }) {

  if (!editable) {
    return (
      <NotEditableItem
        title={props.placeholder}
        value={value ? moment(value).format(props.format) : null}
      />
    );
  }

  let Picker = DatePicker;

  if (picker === 'month') {
    Picker = MonthPicker;
  }

  return (
    <FormItem
      label={label}
      required={required}
      error={error}
      layout={layout}
    >
      <Picker
        name={name}
        value={value ? moment(value, props.format) : null}
        onChange={onChange}
        // defaultValue={moment('2015/01/01', props.format)}
        //format={props.format}
        {...props}
      />
    </FormItem>
  );
}



// WEBPACK FOOTER //
// ./src/components/BaseForm/components/DatePicker.js